import { render, staticRenderFns } from "./PageCorrectionAdd.vue?vue&type=template&id=1de757fc&"
import script from "./PageCorrectionAdd.vue?vue&type=script&lang=js&"
export * from "./PageCorrectionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports